import type { FC } from 'react'

const VoiceListingLoading: FC = () => {
  return Array.from({ length: 20 }).map((_, index) => (
    <div
      key={index}
      className="h-full min-h-[120px] animate-pulse rounded-md bg-white/[7%]"
    />
  ))
}

export default VoiceListingLoading
